import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsFacade } from './facade/reports.facade';
import { ReportsEffects } from './effects/reports.effects';
import { reportsReducer } from 'src/app/store/reports/reducers/reports.reducer';


@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('reports', reportsReducer),
    EffectsModule.forFeature([ReportsEffects])
  ],
  providers: [ReportsFacade]
})
export class ReportsStoreModule { }
